import UserForm from './template';

export default UserForm;
